<template>
  <div class="tile-section" v-if="isInstructionVisible">
    <section-title :highlight="isInstructionVisible">
      <template v-if="isInstructionVisible">Click on a tile below to place it on the board</template>
      <template v-else>My Tiles</template>
    </section-title>

    <div class="tiles-container">
      <div
        v-for="tile in localPlayerTiles"
        :key="tile"
        @click="onClickTile(tile)"
        class="tile"
        :class="{ hidden: isSelected(tile) }"
      >
        {{ tile }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {NS_GAME_STATE, NS_LAYER_STATE, NS_TURN_STATE} from "@/store/constants";
import SectionTitle from "@/components/SectionTitle";

export default {
  name: 'CurrentPlayerTiles',
  components: {
    SectionTitle
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'localPlayer',
      'localPlayerTiles',
      'selectedTile',
      'hasPlacedTile',
      'isMyTurn',
    ]),

    isInstructionVisible() {
      return this.isMyTurn && !this.hasPlacedTile;
    },
  },

  methods: {
    ...mapActions(NS_TURN_STATE, [
      'flowPlaceTile',
    ]),

    ...mapActions(NS_LAYER_STATE, [
      'addToast',
    ]),

    async onClickTile(tileId) {
      await this.flowPlaceTile(tileId);
    },

    isSelected(tileId) {
      return this.selectedTile === tileId;
    }
  }
}
</script>

<style scoped>
.tiles-container {
  display: flex;
  justify-content: space-evenly;
  margin: 10px 0;
}

.tile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  margin: 2px;
  background-color: #3a3a3a;
  color: white;
  cursor: pointer;
  border-width: 5px;
  border-style: solid;
  border-top-color: #5a5a5a;
  border-left-color: #5a5a5a;
  border-right-color: #171717;
  border-bottom-color: #171717;
  box-sizing: border-box;
  box-shadow: 1px 1px 4px #848484;
}

.hidden {
  visibility: hidden;
}
</style>

